import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import queryString from 'query-string';

@connect(
  state => ({
    auth: state.auth,
  })
)
export default class AuthNotRequireContainer extends React.Component {

  static defaultProps = {
    isFree: false,
  };

  componentDidMount() {
    const query = queryString.parse(location.search);
    let destination = query.destination || null;
    let pathname = `${window.location.origin}/auth/signin`;

    window.location.href = destination ? `${pathname}?destination=${destination}` : pathname;
  }

  render() {
    const {
      auth: { isAuthenticated },
      component: Component,
      isFree,
      location,
      ...props
    } = this.props;
    const query = queryString.parse(location.search);
    const path = {
      pathname: '/dashboard',
    };
    if (query.destination) {
      path.pathname = query.destination;
      delete query.destination;
    }
    path.search = queryString.stringify(query);
    return (
      <Route
        {...props}
        render={props =>
          (!isAuthenticated || isFree)
            ? (
                <Component />
              )
            : (
            <Redirect to={{
              pathname: path.pathname,
              search: path.search,
              state: { from: location }
            }} />
          )
        }
      />
    )
  }

}
